import { Box, Grid, Typography } from '@mui/material';
import React from 'react';
import Cards from './Card';

const AuditTrail: any = (data: any) => {
  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ];
  const d = new Date(data?.data[0]?.date_time_of_change);
  return (
    <>
      {data.data.length != 0 ? (
        <Box sx={{ mb: 2 }}>
          {d && d?.getDate() && d?.getFullYear() && (
            <Grid md={12}>
              <Typography variant="h6" component="div" sx={{ mb: 1 }} className="h6-fs16">
                {monthNames[d.getMonth()]} {d.getDate()}, {d.getFullYear()}
              </Typography>
            </Grid>
          )}

          {data?.data?.map((item: React.Key | null | undefined, index: any) => (
            <Cards key={item + '' + index} data={item} />
          ))}
        </Box>
      ) : (
        ' '
      )}
    </>
  );
};

export default React.memo(AuditTrail);
